import React, { useEffect } from "react";

import Album from "../components/album/Album";
import Pricing from "../components/pricing/Pricing";

import translations from "../translations/home";

const Home = (props) => {

  const hero = translations[props.lang].hero;

  useEffect(() => {
    document.title = translations[props.lang].title;
  }, [props.lang]);

  return (
    <div>
      <div className="hero-section">
        <img
          src="https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp"
          alt={hero.title}
        />
        <div className="hero-inner">
          <div className="hero-copy">
            <h1>{hero.title}</h1>
            <p className="sub">{hero.subtitle}</p>
            <div className="hero-ctas">
              <a className="btn btn-primary btn-lg" href="/devis-reservation-vtc/">{hero.cta}</a>
              <a className="btn-ghost" href="tel:+33660265336">{hero.phone}</a>
              <a className="btn-ghost" href={hero.whatsappLink} target="_blank" rel="noreferrer">{hero.whatsapp}</a>
            </div>
          </div>
          <div className="hero-caption"><span className="rule"></span>{hero.caption}</div>
        </div>
      </div>
      <div className="trust-bar">
        <div className="trust-bar-inner">
          {translations[props.lang].trust.map((item) => {
            const externalProps = item.url.startsWith("http")
              ? { target: "_blank", rel: "noreferrer" }
              : {};
            return (
              <a
                key={item.label}
                href={item.url}
                className="trust-badge"
                {...externalProps}
              >
                <b>{item.label}</b>{item.sub ? <> · {item.sub}</> : null}
              </a>
            );
          })}
        </div>
      </div>
      <Pricing lang={props.lang} />
      <div className="routes-section">
        <div className="routes-inner">
          <span className="eyebrow">{translations[props.lang].destinationsLabel}</span>
          <h2>{translations[props.lang].destinationsTitle}</h2>
          <div className="route-chips">
            {translations[props.lang].destinations.map((d) => (
              <span key={d} className={d === "…" ? "more" : undefined}>{d}</span>
            ))}
          </div>
        </div>
      </div>
      <Album lang={props.lang} />
      <div className="closing-section">
        <div className="closing-inner">
          <h2>{translations[props.lang].closing.title}</h2>
          <div className="closing-ctas">
            <a className="btn btn-primary btn-lg" href="/devis-reservation-vtc/">{translations[props.lang].closing.cta}</a>
            <a className="btn-ghost" href="tel:+33660265336">{translations[props.lang].closing.phone}</a>
            <a className="btn-ghost" href={translations[props.lang].closing.whatsappLink} target="_blank" rel="noreferrer">{translations[props.lang].closing.whatsapp}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;